import * as React from 'react';
import IUser from '../models/IUser';

export interface IAppContext {
    user: IUser | undefined;
}

export const AppContext = React.createContext<IAppContext | undefined>(undefined);